export const sxConfig = {
  container: {
    background: '#E9F5FE',
    height: '100vh',
    padding: 1.5,
  },

  wrapper: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'wrap',
  },

  cardContainer: {
    background: '#bbf7d04d',
    color: '#16a34a',
    padding: 3,
    borderRadius: '12px',
  },

  cardTypography: {
    fontSize: '1.5rem',
    textAlign: 'center',
  },
};
